import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const DeviceListMain = styled.div`
  min-width: 440px;
  width: calc(100% - 350px);
  height: 175px;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${ColorSF2.white};
  @media (max-height: 530px) {
    height: 110px;
  }
`;
export const ImageButton = styled.button`
  width: 48px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  background-color: ${ColorSF2.whisperGray};
  border: 0px;
  color: ${ColorSF2.navyBlue};
  font-size: 10px;
  &:hover {
    opacity: 0.5;
  }
  @media (max-height: 530px) {
    // TODO
    width: 48px;
    height: 100%;
  }
`;
export const RemoteButton = styled.button`
  width: 80px;
  height: 32px;
  border-radius: 4px;
  border: 0px;
  margin: 0px 5px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  background-color: ${props =>
    (props.disabled && ColorSF2.mediumGray) ||
    (props.isTalking && ColorSF2.alertRed) ||
    ColorSF2.green};
  color: ${ColorSF2.white};
  font-size: 14px;
  &:hover {
    opacity: ${props => (props.disabled ? 1 : 0.8)};
    background-color: ${props =>
      (props.disabled && ColorSF2.mediumGray) ||
      (props.isTalking && ColorSF2.alertRed) ||
      ColorSF2.green};
  }
  @media (max-height: 530px) {
    // TODO
    width: 60px;
    height: 24px;
    font-size: 11px;
  }
`;
export const DeviceManagerTitle = styled.div`
  width: 100%;
  height: 30px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media (max-height: 530px) {
    font-size: 12px;
    height: 20px;
  }
`;
export const DeviceWrapper = styled.div`
  min-height: 48px;
  display: flex;
  flex-direction: row;
  background-color: ${ColorSF2.whisperGray};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  justify-content: space-between;
  align-items: center;
  padding: 1px 5px;
  @media (max-height: 530px) {
    font-size: 12px;
    height: 30px;
  }
`;
export const DeviceButtons = styled.div`
  width: 250px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;
export const DeviceNameWrapper = styled.div`
  width: calc(100% - 250px);
  display: flex;
  flex-direction: column;
`;
export const DeviceName = styled.div`
  width: 100%;
  flex: 1 1 0%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export const LoginAlert = styled.div`
  width: 100%;
  max-width: 277px;
  padding: 2px;
  background-color: #e6792e;
  border-radius: 2px;
  font-size: 10px;
  color: #fff;
`;
export const BlackboardListButton = styled.div`
  display: ${props => (props.isDisplay ? 'block' : 'none')};
`;
export const RemoteButtonWrapper = styled.div`
  display: ${props => (props.enableRemoteButton ? 'block' : 'none')};
`;
export const LinkButtonImage = styled.img`
  width: 20px;
  height: 20px;
`;
